const INITIAL_STATE = { userData: [] };

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case 'FETCH_USER_LIST':
            return { ...state };
        case 'FETCH_USER_LIST_SUCCESS':
            return { ...state, userData: action.payload };
        case 'FETCH_USER_LIST_FAIL':
            return { ...state };
        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/reducers/UserDetails/UserReducer.js